export default __webpack_public_path__ + "159fed50dff03f991db73db0eb174015.png";